import * as css from './LayoutIcon.css';

export function LayoutIcon({percent}) {
    return (
        <css.wrapper>
            <css.piece percent={percent} />
            {percent !== 100 && <css.others percent={percent} />}
        </css.wrapper>
    );
}